var _defs, _path, _path2, _g, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitivos4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5e7076;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.95,146.79H31.05c-6.78,0-12.3-5.52-12.3-12.3V42.24c0-6.78,5.52-12.3,12.3-12.3H168.95c6.78,0,12.3,5.52,12.3,12.3v92.25c0,6.78-5.52,12.3-12.3,12.3ZM31.05,35.89c-3.5,0-6.34,2.84-6.34,6.34v92.25c0,3.5,2.84,6.34,6.34,6.34H168.95c3.5,0,6.34-2.84,6.34-6.34V42.24c0-3.5-2.84-6.34-6.34-6.34H31.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.9,121.11H42.1c-5.47,0-9.91-4.45-9.91-9.91V51.03c0-5.47,4.45-9.91,9.91-9.91h115.8c5.47,0,9.91,4.45,9.91,9.91v60.17c0,5.47-4.45,9.91-9.91,9.91ZM42.1,47.07c-2.18,0-3.95,1.77-3.95,3.95v60.17c0,2.18,1.77,3.95,3.95,3.95h115.8c2.18,0,3.95-1.77,3.95-3.95V51.03c0-2.18-1.77-3.95-3.95-3.95H42.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.67,169.03l-4.53-3.88c1.88-2.2,3.49-4.61,4.76-7.18,2.2-4.42,3.42-9.23,3.63-14.28l5.96,.25c-.25,5.89-1.67,11.51-4.25,16.69-1.49,3.01-3.37,5.83-5.57,8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.33,169.03c-2.2-2.57-4.08-5.4-5.57-8.41-2.57-5.18-4-10.79-4.25-16.69l5.96-.25c.21,5.05,1.43,9.86,3.63,14.28,1.28,2.57,2.88,4.98,4.76,7.18l-4.53,3.88Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.55,170.07h-55.09c-1.65,0-2.98-1.33-2.98-2.98s1.33-2.98,2.98-2.98h55.09c1.65,0,2.98,1.33,2.98,2.98s-1.33,2.98-2.98,2.98Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 130.97,
    r: 5.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitivos4);
export default __webpack_public_path__ + "static/media/competitivos4.121e4d27582850d877074f092fe55791.svg";
export { ForwardRef as ReactComponent };